import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {
  getCoreDomain,
  CORE_API_ENTRYPOINT,
  headers,
} from '@probatix/common/services/services.helpers'

export const orderApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: getCoreDomain() }),
  endpoints: (builder) => ({
    postTokenForOrder: builder.mutation<any, any>({
      query: ({ email, uuid }) => ({
        body: { email },
        headers: headers(),
        method: 'POST',
        url: `${CORE_API_ENTRYPOINT}/api/v0/orders/${uuid}/send-confirmation-email`,
      }),
    }),
  }),
  reducerPath: 'orderApi',
})

export const usePostTokenOrder = orderApi.endpoints.postTokenForOrder.useMutation

